module.exports = __webpack_public_path__ + "static/img/product2new.064de7c3.png";